import React, { useMemo } from 'react'
import { Box, FormGroup, FormControlLabel, Checkbox, Typography } from '@mui/material'

export default function CheckboxGroupInput({ label, options = [], value = {}, onChange, disabled }) {
  // ensure we always have an entry for every option key (default false)
  const normalized = useMemo(() => {
    const map = {}
    options.forEach((opt) => {
      map[opt.key] = !!(value && Object.prototype.hasOwnProperty.call(value, opt.key) ? value[opt.key] : false)
    })
    return map
  }, [options, value])

  const handleToggle = (key) => {
    const next = { ...normalized, [key]: !normalized[key] }
    if (onChange) onChange(next)
  }

  const color = disabled ? 'rgba(0, 0, 0, 0.38)' : '#000'

  return (
    <Box sx={{ borderBottom: `1px solid ${color}`, color: color, borderRadius: '0', padding: '9px' }}>
      {label && <Typography variant="subtitle2" sx={{ mb: 1 }}>{label}</Typography>}
      <FormGroup row>
        {options.map((opt) => (
          <FormControlLabel
            key={opt.key}
            control={
              <Checkbox
                disabled={disabled}
                checked={!!normalized[opt.key]}
                onChange={() => handleToggle(opt.key)}
                color="primary"
                size="small"
              />
            }
            label={opt.label}
          />
        ))}
      </FormGroup>
    </Box>
  )
}